module.exports = __webpack_public_path__ + "static/img/IMG(2).f8db24ed.jpg";